import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import StudentGuidanceUpdateModal from "../StudentGuidanceUpdateModal";
import StudentGuidanceDeleteModal from "../StudentGuidanceDeleteModal";
import {
  WorkflowStatusChip,
  RevisionRequestLink,
  RevisionRequestDialog,
  STATUS_META,
  workflowMetaColumns,
  WorkflowFilterBar,
  ExportExcelButton,
  applyConditions,
} from "../../../components/WorkflowStatus";

import { updateStudentGuidance, acceptStudentGuidance, requestRevisionStudentGuidance } from "../../../reducer/studentGuidance/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import StudentGuidanceHistoryModal from "../StudentGuidanceHistoryModal";

const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

function StudentGuidanceTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [revisionRow, setRevisionRow] = useState(null);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.type]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateStudentGuidance(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateStudentGuidance(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const acceptStudentGuidance = async (e) => {
    let result = await props.acceptStudentGuidance(e.id, !e.accepted);
    return result;
  };

  const handleAccept = (e) => {
    acceptStudentGuidance(e).then((success) => {
      if (success) {
        props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
  };

  var list = [];
  if (props.type === "all") props.listStudentGuidance.forEach((e) => list.push(e.studentGuidance));
  else props.listStudentGuidanceById.forEach((e) => list.push(e.studentGuidance));

  const columns = [
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "20%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => setHistoryRow(row)}
            >
              Lịch sử
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={(event) => handleDelete(event, row)}
                  >
                    Xoá
                  </Typography>
                )}
                {props.role === "sudo-admin" && row.purposeId !== 4 && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy duyệt" : "Duyệt"}
                    </Typography>
                    <RevisionRequestLink row={row} onClick={setRevisionRow} />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
    {
      title: <b>Tên công trình</b>,
      key: "workName",
      width: "30%",
      searchable: true,
      sorter: (a, b) => a.workName.localeCompare(b.workName),
    },
    {
      title: <b>Loại công trình</b>,
      key: "timeResearchDetailCode",
      width: "25%",
      type: "include",
      filters: [
        {
          text: "Hướng dẫn đề tài sinh viên NCKH được giải cấp khoa/viện",
          value: "51",
        },
        {
          text: "Hướng dẫn đề tài sinh viên NCKH không đạt giải cấp khoa/viện",
          value: "52",
        },
        {
          text: "Hướng dẫn đề tài sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp trường",
          value: "53",
        },
        {
          text: "Hướng dẫn sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp Bộ, và tương đương",
          value: "54",
        },
        {
          text: "Tham gia và Đạt giải NCKH từ cấp bộ trở lên và giải thể thao (đối với GVBM GDTC) từ cấp Trường trở lên",
          value: "55",
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.workType)),
      render: (value) => {
        const typeMap = {
          51: "Hướng dẫn đề tài sinh viên NCKH được giải cấp khoa/viện",
          52: "Hướng dẫn đề tài sinh viên NCKH không đạt giải cấp khoa/viện",
          53: "Hướng dẫn đề tài sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp trường",
          54: "Hướng dẫn sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp Bộ, và tương đương",
          55: "Tham gia và Đạt giải NCKH từ cấp bộ trở lên và giải thể thao (đối với GVBM GDTC) từ cấp Trường trở lên",
        };
        return typeMap[value] || "-";
      },
    },
    {
      title: <b>Đạt giải</b>,
      key: "awardLevel",
      width: "12%",
      type: "include",
      filters: [
        { text: "Giải nhất", value: "first_prize" },
        { text: "Giải nhì", value: "second_prize" },
        { text: "Giải ba", value: "third_prize" },
        { text: "Giải khuyến khích", value: "encouragement_prize" },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.awardLevel)),
      render: (value) => {
        const awardMap = {
          first_prize: "Giải nhất",
          second_prize: "Giải nhì",
          third_prize: "Giải ba",
          encouragement_prize: "Giải khuyến khích",
        };
        return awardMap[value] || "-";
      },
    },
    {
      title: <b>Năm học</b>,
      key: "academicYear",
      width: "12%",
      sorter: (a, b) => (a.academicYear || "").localeCompare(b.academicYear || ""),
    },
    {
      title: <b>Tình trạng</b>,
      key: "_status",
      width: "15%",
      render: (_, row) => <WorkflowStatusChip row={row} />,
      type: "include",
      filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
      onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
    },
    {
      title: <b>Mục đích</b>,
      key: "purposeId",
      width: "15%",
      type: "include",
      filters: props.purposes.map((e) => ({ value: e.id, text: e.description })),
      onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
      render: (value) => props.purposes.find((e) => e.id === value)?.description,
    },
    ...workflowMetaColumns({ width: "10%" }),
  ];

  const enrichedRows = list.map((item) => ({ ...item, _status: deriveStatus(item) }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);
  const departmentName = (props.departments || []).find((d) => d.id === props.department)?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="studentGuidance" />
      </div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={columns}
        rows={filteredRows}
        loading={props.isFetching}
      />
      <StudentGuidanceUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <StudentGuidanceDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <StudentGuidanceHistoryModal open={!!historyRow} row={historyRow} onClose={() => setHistoryRow(null)} />
      <RevisionRequestDialog
        row={revisionRow}
        submitting={revisionSubmitting}
        onClose={() => setRevisionRow(null)}
        onSubmit={async (reason) => {
          setRevisionSubmitting(true);
          const ok = await props.requestRevisionStudentGuidance(revisionRow.id, reason);
          setRevisionSubmitting(false);
          if (ok) setRevisionRow(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  isFetching: select(state, "studentGuidanceReducer", "isFetching"),
  listStudentGuidance: select(state, "studentGuidanceReducer", "listFiltered"),
  listStudentGuidanceById: select(state, "studentGuidanceReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  departments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptStudentGuidance: (id, accept) => dispatch(acceptStudentGuidance(id, accept)),
  requestRevisionStudentGuidance: (id, reason) => dispatch(requestRevisionStudentGuidance(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateStudentGuidance: (id, payload) => dispatch(updateStudentGuidance(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(StudentGuidanceTable));

